import React from "react"
import PropTypes from "prop-types"

const FaPhone = ({ height, width, color, innerClassName }) => (
  <svg
    className={innerClassName}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlinkHref="http://www.w3.org/1999/xlink"
    width={width}
    height={height}
    viewBox="0 0 14 14"
  >
    <path
      style={{ fill: color }}
      d="M11 9.687q0 0.211-0.078 0.551t-0.164 0.535q-0.164 0.391-0.953 0.828-0.734 0.398-1.453 0.398-0.211 0-0.41-0.027t-0.449-0.098-0.371-0.113-0.434-0.16-0.383-0.141q-0.766-0.273-1.367-0.648-1-0.617-2.066-1.684t-1.684-2.066q-0.375-0.602-0.648-1.367-0.023-0.070-0.141-0.383t-0.16-0.434-0.113-0.371-0.098-0.449-0.027-0.41q0-0.719 0.398-1.453 0.438-0.789 0.828-0.953 0.195-0.086 0.535-0.164t0.551-0.078q0.109 0 0.164 0.023 0.141 0.047 0.414 0.594 0.086 0.148 0.234 0.422t0.273 0.496 0.242 0.418q0.023 0.031 0.137 0.195t0.168 0.277 0.055 0.223q0 0.156-0.223 0.391t-0.484 0.43-0.484 0.414-0.223 0.359q0 0.070 0.039 0.176t0.066 0.16 0.109 0.187 0.090 0.148q0.594 1.070 1.359 1.836t1.836 1.359q0.016 0.008 0.148 0.090t0.187 0.109 0.16 0.066 0.176 0.039q0.141 0 0.359-0.223t0.414-0.484 0.43-0.484 0.391-0.223q0.109 0 0.223 0.055t0.277 0.168 0.195 0.137q0.195 0.117 0.418 0.242t0.496 0.273 0.422 0.234q0.547 0.273 0.594 0.414 0.023 0.055 0.023 0.164z"
    />
  </svg>
)

FaPhone.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  color: PropTypes.string,
  innerClassName: PropTypes.string,
}

FaPhone.defaultProps = {
  height: "14",
  width: "11",
  color: "#000000",
}

export default FaPhone
